// extracted by mini-css-extract-plugin
module.exports = {"root":"Instratuction_root__2AhqJ","row":"Instratuction_row__1Vawa"};